import axios from "axios";
import moment from "moment";
import { KEY_LOCALSTORAGE } from "../../auth/core/_consts";
import { localStorageItem } from "../../utils/LocalStorage";
import {
  DocumentKeys,
  THONG_TIN_BENH_AN_CONFIG,
} from "../components/benh-an/constant";
import { APP_CONFIGURATION_KEYS } from "../../utils/Constant";

const API_PATH =
  localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[
    APP_CONFIGURATION_KEYS.INPATIENT_URL
  ] || process.env.REACT_APP_INPATIENT_API_URL;
const CIS_API_PATH =
  localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[
    APP_CONFIGURATION_KEYS.API_URL
  ] || process.env.REACT_APP_API_URL;
const API_FIFTEEN_DAYS_TREATMENT = API_PATH + "/treatment-fifteen-days";
const API_VITAL_SIGNS = API_PATH + "/vital-signs";
const API_TREATMENT_SHEETS = API_PATH + "/treatment-sheets";
const API_CARE_CARD = API_PATH + "/care-card";
const API_CARE_PLAN = API_PATH + "/care-plan";
const API_EXPORT = API_PATH + "/download";
const API_REPORT = `${
  localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[
    APP_CONFIGURATION_KEYS.REPORT_URL
  ] || process.env.REACT_APP_REPORT_API_URL
}/rest/reports/run`;

type IParamsGetDsPhieu = {
  patientId: string;
  visitId?: string;
  medicalRecordCode: string;
};

type IParamsInPhieu = {
  keyConfig: DocumentKeys;
  exportId: string;
  parameters: {
    name: string;
    value: string;
  }[];
  fileType: string;
};

// Get json form
export const getJsonGenerateFormNoiTru = async (code: string) => {
  let url = API_PATH + `/term-models/${code}/model-json`;
  return axios.get(url);
};

// Cay benh an
export const getTreeDataBenhAn = async (params: Partial<IParamsGetDsPhieu>) => {
  let url = API_PATH + `/record-category/tree-list`;
  return axios.get(url, { params });
};

// Phieu dieu tri
export const getDsPhieuDieuTri = (params: IParamsGetDsPhieu) => {
  let url = API_TREATMENT_SHEETS + "/search";
  return axios.get(url, { params });
};

export const createPhieuDieuTri = (data: any) => {
  return axios.post(API_TREATMENT_SHEETS, data);
};

export const updatePhieuDieuTri = (data: any) => {
  return axios.put(API_TREATMENT_SHEETS, data);
};

export const getDetailPhieuDieuTri = (id: any) => {
  let url = API_TREATMENT_SHEETS + `/obs-complex/by-id/${id}`;
  return axios.get(url);
};

export const deletePhieuDieuTri = (id: any, params: any) => {
  let url = API_TREATMENT_SHEETS + `/${id}`;
  return axios.delete(url, { params });
};

// Phieu so ket 15 ngay
export const getDsPhieuSoKet15Ngay = (params: IParamsGetDsPhieu) => {
  let url = API_FIFTEEN_DAYS_TREATMENT + "/search";
  return axios.get(url, { params });
};

export const createPhieuSoKet15Ngay = (data: any) => {
  return axios.post(API_FIFTEEN_DAYS_TREATMENT, data);
};

export const updatePhieuSoKet15Ngay = (data: any) => {
  return axios.put(API_FIFTEEN_DAYS_TREATMENT, data);
};

export const getDetailPhieuSoKet15Ngay = (id: any) => {
  let url = API_FIFTEEN_DAYS_TREATMENT + `/obs-complex/by-id/${id}`;
  return axios.get(url);
};

export const deletePhieuSoKet15Ngay = (id: any, params: any) => {
  let url = API_FIFTEEN_DAYS_TREATMENT + `/${id}`;
  return axios.delete(url, { params });
};

// Theo doi dau hieu sinh ton
export const getDsPhieuTheoDoiDHST = (params: IParamsGetDsPhieu) => {
  let url = API_VITAL_SIGNS + "/search";
  return axios.get(url, { params });
};

export const createPhieuTheoDoiDHST = (data: any) => {
  return axios.post(API_VITAL_SIGNS, data);
};

export const updatePhieuTheoDoiDHST = (data: any) => {
  return axios.put(API_VITAL_SIGNS, data);
};

export const getDetailPhieuTheoDoiDHST = (id: any) => {
  let url = API_VITAL_SIGNS + `/${id}`;
  return axios.get(url);
};

export const deletePhieuTheoDoiDHST = (id: any, params: any) => {
  let url = API_VITAL_SIGNS + `/${id}`;
  return axios.delete(url, { params });
};

export const getPhieuTheoDoiDHSTGanNhat = (medicalRecordCode: any) => {
  let url = API_VITAL_SIGNS + `/obs-complex/previous/${medicalRecordCode}`;
  return axios.get(url);
};

//Phieu cham soc
export const getDsPhieuChamSoc = (params: Partial<IParamsGetDsPhieu>) => {
  let url = API_CARE_CARD + "/search";
  return axios.post(url, params);
};

export const createPhieuChamSoc = (data: any) => {
  return axios.post(API_CARE_CARD, data);
};

export const updatePhieuChamSoc = (data: any) => {
  let url = API_CARE_CARD + `/${data?.id}`;
  return axios.post(url, data);
};

export const getDetailPhieuChamSoc = (id: any) => {
  let url = API_CARE_CARD + `/${id}`;
  return axios.get(url);
};

export const deletePhieuChamSoc = (id: any, params: any) => {
  let url = API_CARE_CARD + `/${id}`;
  return axios.delete(url, { params });
};

//Phieu cham soc ke hoach
export const getDsPhieuChamSocKH = (params: Partial<IParamsGetDsPhieu>) => {
  let url = API_CARE_PLAN + "/search";
  return axios.post(url, params);
};

export const createPhieuChamSocKH = (data: any) => {
  return axios.post(API_CARE_PLAN, data);
};

export const updatePhieuChamSocKH = (data: any) => {
  let url = API_CARE_PLAN + `/${data?.id}`;
  return axios.post(url, data);
};

export const getDetailPhieuChamSocKH = (id: any) => {
  let url = API_CARE_PLAN + `/${id}`;
  return axios.get(url);
};

export const deletePhieuChamSocKH = (id: any, params: any) => {
  let url = API_CARE_PLAN + `/${id}`;
  return axios.delete(url, { params });
};

//in phieu
export const inPhieuChamSoc = async (params: any) => {
  let url = API_EXPORT + "/care-card";
  return await axios.post<Blob>(url, params, { responseType: "blob" });
};

export const inPhieuTruyenDich = async (params: any) => {
  let url = API_EXPORT + "/infusion-monitoring";
  return await axios.post<Blob>(url, params, { responseType: "blob" });
};

export const inBienBanHoiChan = async (params: any) => {
  let url = API_EXPORT + "/consultation";
  return await axios.post<Blob>(url, params, { responseType: "blob" });
};

export const inBienBanHoiChanPhauThuat = async (params: any) => {
  let url = API_EXPORT + "/surgical-consultation";
  return await axios.post<Blob>(url, params, { responseType: "blob" });
};

export const inPhieuHoSoBenhAn = async (data: IParamsInPhieu) => {
  const { keyConfig, exportId, parameters, fileType } = data;
  let requestBody = {
    parameters,
    template: THONG_TIN_BENH_AN_CONFIG?.[keyConfig]?.TEMPLATE?.[fileType],
  };
  let url = API_REPORT + `/${exportId}`;
  return await axios.post<Blob>(url, requestBody, { responseType: "blob" });
};

export const inPhieuDieuTri = async (params: any) => {
  let url = API_EXPORT + "/treatment-sheet";
  return await axios.post<Blob>(url, params, { responseType: "blob" });
};

export const inPhieuDieuTriKySo = async (params: any) => {
  let url = API_PATH + "/template/PHIEU_DIEU_TRI";
  return await axios.get<Blob>(url, { params, responseType: 'blob' });
};

export const inPhieuSoKet15Ngay = async (params: any) => {
  let url = API_EXPORT + "/treatment-fifteen-days";
  return await axios.post<Blob>(url, params, { responseType: "blob" });
};

export const inPhieuChamSocKH = async (params: any) => {
  let url = API_EXPORT + "/care-plan";
  return await axios.post<Blob>(url, params, { responseType: "blob" });
};

// Get patient treatment sheet history from both CIS and Inpatient services
export const getPatientTreatmentSheetHistory = async (patientId: string, justCis?: boolean) => {
  try {
    // Call both APIs in parallel
    const [inpatientResponse, cisResponse] = await Promise.allSettled([
      ...(!justCis ? [axios.get(API_TREATMENT_SHEETS + "/patient-history", {
        params: { patientId },
      })] : [null]),
      axios.get(
        CIS_API_PATH + "/medical-exam/treatment-sheets/patient-history",
        { params: { patientId } }
      ),
    ]);

    // Merge results
    const inpatientData =
      inpatientResponse?.status === "fulfilled"
        ? inpatientResponse.value?.data?.data || []
        : [];
    const cisData =
      cisResponse?.status === "fulfilled"
        ? cisResponse.value?.data?.data || []
        : [];

    // Combine and sort by date
    const combined = [
      ...inpatientData.map((item: any) => ({ ...item, source: "INPATIENT" })),
      ...cisData.map((item: any) => ({
        id: item.encounter?.id,
        // orderId đã có trong API response (MedicalExamResDto)
        orderId: item.orderId,
        encounterId: item.encounter?.id,
        patientId: item.encounter?.patientId,
        visitId: item.encounter?.visitId || item.visit?.id,
        encounterDatetime: item.encounter?.encounterDatetime,
        medicalRecordCode: item.encounter?.medicalRecordCode,
        medicalRecordTypeCode: item.encounter?.medicalRecordTypeCode,
        medicalRecordTypeName: item.encounter?.medicalRecordTypeName,
        source: "CIS",
      })),
    ];

    // Sort by prescriptionDate or encounterDatetime DESC
    combined.sort((a: any, b: any) => {
      const dateA = new Date(a.prescriptionDate || a.encounterDatetime || 0);
      const dateB = new Date(b.prescriptionDate || b.encounterDatetime || 0);
      return dateB.getTime() - dateA.getTime();
    });

    return { data: { code: "OK", data: combined } };
  } catch (error) {
    console.error("Error fetching patient treatment sheet history:", error);
    return { data: { code: "ERROR", data: [] } };
  }
};

export const updateTreatmentInputDate = async (
  id: string,
  formData: any
) => {

  const url = API_PATH + `/update-fields/${id}/input-date`;
  return axios.post(url, formData);
};

export const getPatientTreatmentSheetHistoryDetail = async (orderId: string) => {
  const url = CIS_API_PATH + `/medical-exam/treatment-sheet/detail`;
  return axios.get(url, { params: { orderId } });
}

export const getSignatureInfo = async (params: any) => {
  const url = API_PATH + `/signature/info`;
  return axios.get(url, { params });
}